import React from "react"
import { Gallery } from "./gallery"
import { Transformer } from "../../types"

export const galleryTransformer: Transformer = (node, i, { classList = [], children }) => {
  if (classList.includes("wp-block-gallery")) {
    return <Gallery className={classList.join(" ")} children={children} />
  }
}
